import {inject, Injectable, DOCUMENT} from '@angular/core';

import {PlatformService} from "./platform.service";

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private platformService = inject(PlatformService)
  private document = inject(DOCUMENT)

  toTop(top: number) {
    if (this.platformService.isBrowser()) {
      this.document?.getElementById('pageContainer')?.scrollTo({top, behavior: 'auto'});
      this.document?.getElementById('scrollContainer')?.scrollTo({top, behavior: 'auto'});
    }
  }
}
